import { useSyncExternalStore } from 'react';
import { realtimeRuntime } from './realtimeRuntime.js';

const subscribe = (listener) => realtimeRuntime.subscribe(listener);
const getSnapshot = () => realtimeRuntime.currentConsumer();
const getServerSnapshot = () => null;

export const useRealtimeConsumer = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
